var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.71 10.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2tCsU6",
    "data-name": "2tCsU6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,1.15V.38A.38.38,0,0,1,2.29,0,.39.39,0,0,1,2.7.28a.57.57,0,0,1,0,.13c0,.22,0,.45,0,.67v.07h4.1V1.08c0-.23,0-.46,0-.69A.38.38,0,0,1,7.21,0a.38.38,0,0,1,.38.39v.76H9a.73.73,0,0,1,.75.75V9.68a.74.74,0,0,1-.75.75H.75A.74.74,0,0,1,0,9.68V1.9a.74.74,0,0,1,.75-.75H2ZM.58,3.92V9.35a.51.51,0,0,0,.53.53H8.69a.45.45,0,0,0,.45-.45c0-1.82,0-3.64,0-5.45V3.92ZM6.82,1.66a.58.58,0,0,0-.17.63.59.59,0,0,0,1.13-.07.55.55,0,0,0-.19-.55v.42a.38.38,0,1,1-.76,0C6.82,2,6.82,1.81,6.82,1.66Zm-4.1,0v0c0,.13,0,.26,0,.39a.38.38,0,0,1-.38.4A.39.39,0,0,1,2,2.09V1.66a.59.59,0,0,0-.07.82.6.6,0,0,0,.87,0A.59.59,0,0,0,2.72,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.89,6.87V6.52a.21.21,0,0,1,.22-.23h.71a.21.21,0,0,1,.23.22v.71a.22.22,0,0,1-.23.23h-.7a.21.21,0,0,1-.23-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.89,5.13V4.78a.21.21,0,0,1,.22-.23h.71a.22.22,0,0,1,.23.22V5.5a.21.21,0,0,1-.22.21H7.1a.2.2,0,0,1-.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.57,5.13v.36a.21.21,0,0,1-.22.22H3.62a.2.2,0,0,1-.21-.22V4.77a.21.21,0,0,1,.22-.22h.72a.21.21,0,0,1,.22.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.31,5.13v.36a.21.21,0,0,1-.23.22H5.37a.21.21,0,0,1-.22-.23v-.7a.21.21,0,0,1,.22-.23h.72a.22.22,0,0,1,.22.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.83,5.14v.35a.2.2,0,0,1-.21.22H1.88a.2.2,0,0,1-.21-.21V4.77a.21.21,0,0,1,.21-.22h.74a.22.22,0,0,1,.21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.67,6.87V6.51a.21.21,0,0,1,.23-.22h.7a.22.22,0,0,1,.23.23v.71a.2.2,0,0,1-.21.22H1.88a.2.2,0,0,1-.21-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.31,6.87v.36a.22.22,0,0,1-.23.22H5.37a.21.21,0,0,1-.22-.23v-.7a.22.22,0,0,1,.23-.23h.7a.22.22,0,0,1,.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.15,8.66V8.3a.21.21,0,0,1,.22-.21h.72a.21.21,0,0,1,.22.21V9a.21.21,0,0,1-.22.21H5.36A.2.2,0,0,1,5.15,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.41,6.86V6.5a.2.2,0,0,1,.21-.21h.74a.2.2,0,0,1,.21.21v.73a.21.21,0,0,1-.22.21H3.62a.21.21,0,0,1-.21-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.25,9.24H1.89A.2.2,0,0,1,1.67,9V8.31a.21.21,0,0,1,.23-.22h.71a.2.2,0,0,1,.22.22V9a.21.21,0,0,1-.22.22H2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.57,8.67V9a.21.21,0,0,1-.21.21H3.62A.2.2,0,0,1,3.41,9V8.3a.21.21,0,0,1,.21-.21h.74a.21.21,0,0,1,.21.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.f679208a42b65301a08541f9af5a72d8.svg";
export { ForwardRef as ReactComponent };